'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _dashboard = require('./dashboard/dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _list = require('./dashboard/list/list');

var _list2 = _interopRequireDefault(_list);

var _detail = require('./dashboard/detail/detail');

var _detail2 = _interopRequireDefault(_detail);

var _description = require('./dashboard/detail/description/description');

var _description2 = _interopRequireDefault(_description);

var _map = require('./dashboard/detail/map/map');

var _map2 = _interopRequireDefault(_map);

var _gallery = require('./dashboard/detail/gallery/gallery');

var _gallery2 = _interopRequireDefault(_gallery);

var _comments = require('./dashboard/comments/comments');

var _comments2 = _interopRequireDefault(_comments);

var _users = require('./dashboard/users/users');

var _users2 = _interopRequireDefault(_users);

var _information = require('./dashboard/information/information');

var _information2 = _interopRequireDefault(_information);

var _addNew = require('./dashboard/information/addNew/addNew');

var _addNew2 = _interopRequireDefault(_addNew);

var _login = require('./login/login');

var _login2 = _interopRequireDefault(_login);

var _confirmRegistration = require('./confirmRegistration/confirmRegistration');

var _confirmRegistration2 = _interopRequireDefault(_confirmRegistration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentModule = _angular2.default.module('app.components', [_dashboard2.default, _list2.default, _detail2.default, _description2.default, _map2.default, _gallery2.default, _comments2.default, _users2.default, _information2.default, _addNew2.default, _login2.default, _confirmRegistration2.default]).name;

exports.default = componentModule;


// WEBPACK FOOTER //
// ./client/app/components/components.js